import type {
    IExtractedTemplateValue,
    IListExtractionWarning,
    IListSourceExtractionFieldResult,
    IWasteReturnListSourceMapping,
} from "../../customTypings/spreadsheetTemplate/SpreadsheetTemplate";

export const LIST_EXTRACTION_SAMPLE_LIMIT = 3;

export interface ListSourceFieldExtractionSummary {
    fieldKey: string;
    extractedCount: number;
    warningCount: number;
    sampleRawValues: string[];
    warnings: IListExtractionWarning[];
}

export function getListSourceExtractedCount(listSource?: IWasteReturnListSourceMapping | null): number {
    return listSource?.extractedValues?.length ?? 0;
}

export function getListSourceWarningCount(fieldResult?: IListSourceExtractionFieldResult | null): number {
    return fieldResult?.warnings?.length ?? 0;
}

export function getSampleRawValues(values: IExtractedTemplateValue[] | undefined, limit = LIST_EXTRACTION_SAMPLE_LIMIT): string[] {
    return (values ?? []).slice(0, limit).map((value) => value.rawValue);
}

export function buildListSourceFieldSummary(
    fieldKey: string,
    listSource?: IWasteReturnListSourceMapping | null,
    fieldResult?: IListSourceExtractionFieldResult | null
): ListSourceFieldExtractionSummary {
    const extractedValues = listSource?.extractedValues ?? fieldResult?.sampleValues ?? [];
    return {
        fieldKey,
        extractedCount: listSource?.extractedValues?.length ?? fieldResult?.extractedCount ?? 0,
        warningCount: fieldResult?.warnings?.length ?? 0,
        sampleRawValues: getSampleRawValues(extractedValues),
        warnings: fieldResult?.warnings ?? [],
    };
}

export function applyExtractListValuesResponse(
    extractionFields: IListSourceExtractionFieldResult[]
): Record<string, IListSourceExtractionFieldResult> {
    return extractionFields.reduce<Record<string, IListSourceExtractionFieldResult>>((acc, field) => {
        acc[field.fieldKey] = field;
        return acc;
    }, {});
}
